// @ts-nocheck
import { debounce } from 'lodash';
import { useCallback, useEffect } from 'react';

export const useDebounce = (value: any, delay: number, deps?: React.DependencyList) =>
  useCallback(debounce(value, delay), deps ?? []);

export const useDebouncedEffect = (effect: React.EffectCallback, delay: number, deps?: React.DependencyList) =>
  useEffect(useDebounce(effect, delay), deps);
